import { resolvable }                                from '@mathquis/modelx-resolvables';
import doc                                           from 'decorators/doc';
import model                                         from 'decorators/model';
import { Timestampable }                             from 'helpers/traits';
import { Blamable }                                  from 'helpers/traits';
import SalesPrivateApiModel                          from '../../abstracts/SalesPrivateApiModel';
import ContractModel                                 from './ContractModel';
import OptionTypeModel                               from './OptionTypeModel';

@model.staticLabel('ContractOptionType')
@model.urnResource('contract_option_type')
@doc.path('/contract_option_types/{?id}')
export default class ContractOptionTypeModel extends Blamable(Timestampable(SalesPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'contract': id;
		'optionType.reference': SalesOptionTypeReference;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
	}> = {};

	@resolvable(ContractModel, { attributeName: 'contract' })
	declare contract: ContractModel;

	@resolvable(OptionTypeModel, { attributeName: 'optionType' })
	declare optionType: OptionTypeModel;

	public get optionTypeId() {
		return this.get('optionType.id');
	}
}
